import httpClient from '@/app/utils/axios';
import { Result } from '@/app/api/models/baseModel';
import { Classroom } from '@/app/api/models/classroom';
import { Module } from '@/app/api/models/module';
import { Session } from '@/app/api/models/session';
import { BaseModuleState } from '@/app/services/modules/BaseModuleService';
import { SessionModule } from './models/sessionModule';
import { axiosQueue } from '@/app/utils/axiosQueue';
import { isTeacher } from '@/app/helpers/userHelper';

interface ClassroomSession {
    session: Session;
    state: BaseModuleState;
    module: Module;
}

export function storeSessionModule(
    classroom: Classroom,
    module: Module,
    options: Record<string, unknown>,
    curriculumId?: number | null,
) {
    const params = {
        classroom_id: classroom.id,
        curriculum_id: curriculumId,
        module_id: module.id,
        options,
    };

    return httpClient.post<Result<ClassroomSession>>(route('app.teacher.session-modules.store'), params);
}

export function updateModuleResult<EventResponse = unknown>(
    sessionModule: SessionModule,
    event: string,
    data: unknown,
) {
    return httpClient.put<
        Result<{
            event_response: EventResponse;
            state: BaseModuleState;
        }>
    >(route('app.teacher.session-modules.update', { sessionModule }), {
        event,
        data,
    });
}

export function updateStudentModuleResult<EventResponse = unknown>(
    sessionModule: SessionModule,
    event: string,
    data: unknown,
    preserveWhitespace?: boolean,
) {
    return axiosQueue.enqueue(() =>
        httpClient.put<
            Result<{
                event_response: EventResponse;
                state: BaseModuleState;
            }>
        >(route('app.session-modules.update', { sessionModule }), {
            event,
            data,
            preserve_whitespace: preserveWhitespace,
        }),
    );
}

export function doneModule(sessionModule: SessionModule) {
    return httpClient.put<Result<ClassroomSession>>(route('app.teacher.session-modules.done', { sessionModule }));
}

export function getSessionModuleResult(sessionModule: SessionModule, isAllStudents?: boolean) {
    const routeName = isTeacher() ? 'app.teacher.session-modules.show' : 'app.session-modules.show';

    return httpClient.get<
        Result<{
            module: Module;
            session_module: SessionModule;
            students: {
                [studentId: number]: unknown;
            };
        }>
    >(route(routeName, { sessionModule }), {
        params: {
            all_students: isAllStudents,
        },
    });
}

export function getSessionModuleStudentsResult(sessionModule: SessionModule) {
    const routeName = isTeacher() ? 'app.teacher.session-modules.student-result' : 'app.session-modules.student-result';

    return httpClient.get<
        Result<{
            students: {
                [studentId: number]: unknown;
            };
            student_states: {
                [studentId: number]: unknown;
            };
        }>
    >(route(routeName, { sessionModule }));
}
